import axios from 'axios';

// axios 配置
axios.defaults.timeout = 15000;
const DEV_DOMAIN = 'https://api.qishimai.com';; // 测试服务器
// const DOMAIN = 'https://www.qishimai.cn/70core'; // 正式
const DOMAIN = 'https://api.qishimai.com'; // 正式

const isDev = process.env.NODE_ENV !== 'production';
axios.defaults.baseURL = isDev ? DEV_DOMAIN : DOMAIN;
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.data = JSON.stringify(config.data);
    }
    return config;
  },
  err => Promise.reject(err),
);

// 返回拦截器
axios.interceptors.response.use(
  (response) => {
    if (parseInt(response.data.code, 10) >= 200) {
      try {
        response.data.data = JSON.parse(response.data.data);
        // eslint-disable-next-line
      } catch (e) { }
      return Promise.resolve(response);
    }
    const errMsg = Object.assign(response, { errType: 'server' });
    return Promise.reject(errMsg);
  },
  (error) => {
    if (error.request.status >= 400 && error.request.status < 500) {
      const errMsg = Object.assign(error, { errType: 'http', data: { msg: '网络错误' } });
      return Promise.reject(errMsg);
    }
    if (error.request.status >= 500) {
      const errMsg = Object.assign(error, { errType: 'server', data: { msg: '服务器错误' } });
      return Promise.reject(errMsg);
    }
    // TODO 暂时将以下错误全部处理成网络连接失败
    if (error.code) {
      // ECONNABORTED 远程主机拒绝网络连接
      const errMsg = Object.assign(error, { data: { msg: `${error.code}, 请检查网络连接` } });
      return Promise.reject(errMsg);
    }
    const errMsg = Object.assign(error, { data: { msg: '未知错误' } });
    return Promise.reject(errMsg);
  },
);

/* GET请求 */
function get(url, params) {
  // axios.defaults.timeout = 8000;
  return axios
    .get(url, { params });
  // .then()
  // .catch();
}

/* POST请求 */
function post(url, params, contentType = 'application/json') {
  return axios
    .post(url, params, { headers: { 'Content-Type': contentType } });
  // .then()
  // .catch();
}

export { axios, get, post };



// WEBPACK FOOTER //
// ./src/utils/config.http.js